import React from "react";
import OvertimeTable from "./components/OvertimeTable";
import { connect } from "react-redux";

const Overtimes = () => {
    
	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">      		
	      	<OvertimeTable />
	      </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(Overtimes);